import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function postLogin(payload) {
  return $apiClient.post(`${ApiConfig.LOGIN}`,payload);
}
